module.exports = __webpack_public_path__ + "static/media/login.6449593e.jpeg";